import React, { Component } from "react";
import { connect } from "react-redux";
import { Alert, Images, Loading, Screen } from "../../components";
import HomeCourasel from "../../components/common/homePage/Courasel/HomeCourasel";
import { init } from "../../redux/actions/appActions";
import {
  loadAllBetTypes,
  setEvent,
} from "../../redux/actions/sportEventsActions";
import LiveMatches from "../../components/common/homePage/Courasel/LiveMatches";
import HomeBanners from "../../components/common/homePage/Banners/HomeBanners";
import BettingImg from "../../components/common/homePage/BettingImg/BettingImg";
import HomeSlots from "../../components/common/homePage/Slots/HomeSlots";
import { useMediaQuery } from "react-responsive";
import { loadTopBets } from "../../redux/actions/sportEventsActions";
import { loadSportTypes } from "../../redux/actions/sportTypesActions";
import { GetLandingConfiguration } from "../../redux/actions/generalActions";
const IsMiddleScreenAndMobile = ({ children }) => {
  const isDesktop = useMediaQuery({ maxWidth: 1100 });
  return isDesktop ? children : null;
};

const IsDesktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1100 });
  return isDesktop ? children : null;
};
export class Home extends Component {
  componentDidMount() {
    const {
      connected,
      loadTopBets,
      loadSportTypes,
      GetLandingConfiguration,
    } = this.props;
    GetLandingConfiguration();
    if (connected) {
      let sportTypesRequest = {
        Data: {
          Feed: {
            FeedId: 6,
          },
        },
      };
      loadSportTypes(sportTypesRequest);
    }
  }
  componentDidUpdate(prevProps) {
    const { connected, loadTopBets, loadSportTypes } = this.props;
    if (prevProps.connected !== connected && connected) {
      let sportTypesRequest = {
        Data: {
          Feed: {
            FeedId: 6,
          },
        },
      };
      loadSportTypes(sportTypesRequest);
    }
  }
  render() {
    const {
      error,
      sportEvents,
      loadingSportEvents,
      sportTypesIcons,
      sportTypes,
      sportTypesError,
      loadingSportTypes,
      history,
      loadingLandingPage,
      landingBanners,
      landingPromos,
      landingSlotsGame,
      landingPageError,
      landingBettingImage,
      sections
    } = this.props;
    let bannersSection = sections && sections.filter(item=> item.landingId == 1 && item.isActive == true)
    let sportsSection = sections && sections.filter(item=> item.landingId == 2 &&  item.isActive == true)
    let promosSection = sections && sections.filter(item=> item.landingId == 3 &&  item.isActive == true)
    let slotsSection = sections && sections.filter(item=> item.landingId == 4 &&  item.isActive == true)
    let isBannerSectionActive = bannersSection && bannersSection.length > 0
    let isSportsSectionActive = sportsSection && sportsSection.length > 0
    let isPromosSectionActive = promosSection && promosSection.length > 0
    let isSlotsSectionActive = slotsSection && slotsSection.length > 0
    return (
      <Screen {...this.props}>
        {loadingLandingPage ? (
          <div className="events">
            <div className="lds-parent-ring">
              <div className="lds-ring">
                <div />
                <div />
                <div />
                <div />
              </div>
            </div>
          </div>
        ) : landingPageError ? (
          <Alert type="error" message={landingPageError} />
        ) : (
          <div className="home-page">
            {landingBanners && landingBanners.length > 0 && isBannerSectionActive && (
              <HomeBanners landingBanners={landingBanners} history={history} />
            )}
            <IsDesktop>
              {sportTypesError ? (
                <Alert type="error" message={sportTypesError} />
              ) : sportTypes && sportTypes.length > 0 && isSportsSectionActive ? (
                <HomeCourasel
                  type={"Sports"}
                  title={"Sports"}
                  sportTypesIcons={sportTypesIcons}
                  sportTypes={sportTypes}
                  history={history}
                  navUrl={`/sport/6/1/Soccer`}
                />
              ) : loadingSportTypes ? (
                <Loading text={"Loading Sport Types..."} />
              ) : null}

              {landingPromos && isPromosSectionActive && (
                <HomeCourasel
                  landingPromos={landingPromos}
                  type={"Promos"}
                  title={"Promos"}
                  history={history}
                  navUrl={`/promos`}
                />
              )}
            </IsDesktop>
            <IsMiddleScreenAndMobile>
              {sportTypesError ? (
                <Alert type="error" message={sportTypesError} />
              ) : sportTypes && sportTypes.length > 0 && isSportsSectionActive ? (
                <HomeCourasel
                  type={"Sports"}
                  title={"Sports"}
                  isMobile={true}
                  sportTypesIcons={sportTypesIcons}
                  sportTypes={sportTypes}
                  history={history}
                  navUrl={`/sport/6/1/Soccer`}
                />
              ) : loadingSportTypes ? (
                <Loading text={"Loading Sport Types..."} />
              ) : null}
              {landingPromos && isPromosSectionActive && (
                <HomeCourasel
                  landingPromos={landingPromos}
                  type={"Promos"}
                  title={"Promos"}
                  isMobile={true}
                  history={history}
                />
              )}
            </IsMiddleScreenAndMobile>
            {landingSlotsGame && isSlotsSectionActive && <HomeSlots landingSlotsGame={landingSlotsGame} history={history} navUrl={`/slots`}/>}
            {landingBettingImage && isSlotsSectionActive && <BettingImg landingBettingImage={landingBettingImage} history={history}/>}
          </div>
        )}
      </Screen>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    connecting: state.signalr.staticConnecting,
    connected: state.signalr.staticConnected,
    feedId: state.app.feedId,
    feedName: state.app.feedName,
    sportData: state.sportTypes.sportData,
    tournamentData: state.categories.tournamentData,
    mainTournamentImage: state.general.configuration.mainTournamentImage,
    showMainTournament: state.general.configuration.showMainTournament,
    sportEvents: state.sportEvents.sportEvents,
    loadingSportEvents: state.sportEvents.loadingSportEvents,
    error: state.sportEvents.error,
    sportTypesIcons: state.general.sportTypesIcons,
    sportTypes: state.sportTypes.sportTypes,
    sportTypesError: state.sportTypes.error,
    loadingSportTypes: state.sportTypes.loadingSportTypes,
    loadingLandingPage: state.general.loadingLandingPage,
    landingBanners: state.general.landingBanners,
    landingPromos: state.general.landingPromos,
    landingSlotsGame: state.general.landingSlotsGame,
    landingPageError: state.general.landingPageError,
    landingBettingImage: state.general.landingBettingImage,
    sections: state.general.sections,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadAllBetTypes: () => {
      dispatch(loadAllBetTypes());
    },
    setEvent: (item) => {
      dispatch(setEvent(item));
    },
    init: () => {
      dispatch(init());
    },
    loadTopBets: (request) => {
      dispatch(loadTopBets(request));
    },
    loadSportTypes: (request) => {
      dispatch(loadSportTypes(request));
    },
    GetLandingConfiguration: () => {
      dispatch(GetLandingConfiguration());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
